import { makeStyles } from '@material-ui/core/styles';
import { colorMap, TextColors } from '@/utils/constants';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      display: 'flex',
      width: '100%',
      alignItems: 'flex-start',
      alignContent: 'flex-start',

      '&': {
        [muiTheme.breakpoints.down('sm')]: {
          flexDirection: 'column',
        },

        [muiTheme.breakpoints.up('md')]: {
          flexDirection: 'row',
        },
      },
    },
    card: {
      background: colorMap.white,
      borderRadius: '4px',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',

      '&': {
        [muiTheme.breakpoints.down('sm')]: {
          width: '100%',
          padding: '22px 24px 32px',
        },

        [muiTheme.breakpoints.up('md')]: {
          width: '65%',
          padding: '50px 100px',
        },
      },
    },
    jumplinks: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',

      '&': {
        [muiTheme.breakpoints.down('sm')]: {
          marginTop: '28px',
          width: '100%',
          alignItems: 'center',
          alignContent: 'center',
        },

        [muiTheme.breakpoints.up('md')]: {
          marginTop: '218px',
          marginLeft: '98px',
          width: '35%',
          alignItems: 'flex-start',
          alignContent: 'flex-start',
        },
      },
    },
    breadcrumb: {
      '&': {
        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: '26px',
        },

        [muiTheme.breakpoints.up('md')]: {
          marginBottom: '34px',
        },
      },
    },
    superheading: {
      '&.MuiTypography-root': {
        color: TextColors.dark,
        marginBottom: muiTheme.spacing(1),
      },
    },
    logo: {
      '&': {
        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: '16px',
        },

        [muiTheme.breakpoints.up('md')]: {
          marginBottom: '22px',
        },
      },
    },
    logoImage: {
      height: '116px',
      justifyContent: 'flex-start',

      '& img': {
        width: 'auto !important',
        height: '100% !important',
      },
    },
    headline: {
      marginBottom: '6px',

      '&': {
        [muiTheme.breakpoints.up('md')]: {
          marginBottom: '16px',
        },
      },

      '& *, & p, & h1, & h2, & h3, & h4, & h5, & h6': {
        ...muiTheme.typography.h2,
      },

      '& *': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    subheading: {
      '& h1': {
        ...muiTheme.typography.h1,
      },

      '& h2, & h3': {
        ...muiTheme.typography.h3,
      },

      '& h4, & h5, & h6': {
        ...muiTheme.typography.h4,
      },

      '& *': {
        marginTop: 0,
        marginBottom: 0,

        '& + *': {
          marginTop: '16px',
        },
      },

      '& p': {
        ...muiTheme.typography.h5,

        '& bold, & strong': {
          ...muiTheme.typography.h6,
        },
      },
    },
    ctas: {
      margin: muiTheme.spacing(-1.5),
      display: 'flex',
      flexWrap: 'wrap',

      '&': {
        [muiTheme.breakpoints.down('md')]: {
          marginTop: '10px',
        },

        [muiTheme.breakpoints.up('md')]: {
          marginTop: '24px',
        },
      },

      '& > .buttonWrapper': {
        padding: muiTheme.spacing(1.5),

        '& > *': {
          width: '100%',
        },

        [muiTheme.breakpoints.down('xs')]: {
          width: '100%',
        },
      },
    },
  }),
  { name: 'GenHeroCardContent' },
);

export default useStyles;
